import { RefObject } from 'react';

import { updateItemRequest } from '@uderly/react-uderly-ui/api';
import { IndexedRow, ModuleHandle } from "@uderly/react-uderly-ui/models";
import ModuleType from '../models/ModuleType';
import Settings from '../../../settings';
import { PublishableRow } from '../models/PublishableRow';

export interface ModuleUtilsProps {
  data: ModuleType;
}

const useModuleUtils = ({ data }: ModuleUtilsProps) => {
  const onUpdateRecord = async (
    row: IndexedRow,
    moduleRef?: RefObject<ModuleHandle> | null
  ) => {
    if (data) {
      const url = Settings.apiUrl + data.apiBasePath + '/' + row.id;
      const response = await updateItemRequest(url, row);

      if (moduleRef && response && response.status === 202
        && moduleRef.current?.updateRecord) {
        moduleRef.current?.updateRecord(row as IndexedRow);
      }
    }
  };

  const onTogglePublished = async (
    row: PublishableRow,
    moduleRef?: RefObject<ModuleHandle> | null
  ) => {
    await onUpdateRecord(
      { ...row, published: !row.published } as PublishableRow,
      moduleRef
    );
  };

  return { onUpdateRecord, onTogglePublished };
};

export default useModuleUtils;
